import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import withTranslations from '../../utils/HighOrderComponent';

const CheckboxGroupTwoChoices = (props) => {
  const {
    question,
    choice1Label,
    choice2Label,
    value1,
    value2,
    name,
    t,
    disableChoice1,
    disableChoice2,
  } = props || {};

  const [choice1, setChoice1] = useState(false);
  const [choice2, setChoice2] = useState(false);

  useEffect(() => {
    if (value1 !== null && value2 !== null) {
      setChoice1(value1);
      setChoice2(value2);
    }
  }, [value1, value2]);

  const handleCheckChange = (e) => {
    if (e.target.name === 'choice1') {
      if (!choice1) {
        setChoice1(e.target.checked);
        setChoice2(!e.target.checked);
        props.handleCheckChoiceSet &&
          props.handleCheckChoiceSet(name, e.target.checked, !e.target.checked);
      }
    } else {
      if (!choice2) {
        setChoice1(!e.target.checked);
        setChoice2(e.target.checked);
        props.handleCheckChoiceSet &&
          props.handleCheckChoiceSet(name, !e.target.checked, e.target.checked);
      }
    }
  };

  const choice1Text = choice1Label ? choice1Label : t.Labels.choice1;
  const choice2Text = choice2Label ? choice2Label : t.Labels.choice2;
  const choice2DivStyle = disableChoice2 ? 'form-group ' : 'form-group';
  const choice1DivStyle = disableChoice1 ? 'form-group ' : 'form-group';
  const choice2LabelStyle = disableChoice2
    ? 'faded-letter checkbox-font-size'
    : 'textShadow checkbox-font-size';
  const choice1LabelStyle = disableChoice1
    ? 'faded-letter checkbox-font-size'
    : 'textShadow checkbox-font-size';

  return (
    <div className="w-100">
      <label>{question}</label>
      <Row>
        <Col disabled md={5} className={choice1DivStyle}>
          <label htmlFor="choice1" className={choice1LabelStyle}>
            <span className="bullet-char">&bull;</span>
            {choice1Text}
          </label>
          <input
            type="checkbox"
            id="choice1"
            name="choice1"
            className="ml-2 filled-in"
            style={{ cursor: 'pointer' }}
            checked={choice1}
            onChange={handleCheckChange}
            disabled={disableChoice1}
          />
        </Col>
        <Col disabled md={6} className={choice2DivStyle}>
          <label htmlFor="choice2" className={choice2LabelStyle}>
            <span className="bullet-char">&bull;</span>
            {choice2Text}
          </label>
          <input
            type="checkbox"
            id="choice2"
            name="choice2"
            className="ml-2 filled-in"
            style={{ cursor: 'pointer' }}
            checked={choice2}
            onChange={handleCheckChange}
            disabled={disableChoice2}
          />
        </Col>
      </Row>
    </div>
  );
};

export default withTranslations(
  CheckboxGroupTwoChoices,
  'CheckboxGroupTwoChoices'
);
